import { getTripDashboardApi } from "../../helpers/backend_helper";
import {
    setTripDashboardData,
    loadingTripDashboard,
    tripDashboardError,
} from "./reducer";

export const fetchTripDashboard = () => async (dispatch) => {
    try {
        dispatch(loadingTripDashboard(true));

        const response = await getTripDashboardApi();
        dispatch(setTripDashboardData(response[0]));

    } catch (error) {
        const message = error?.response?.data?.detail || "Failed to load trip dashboard.";
        dispatch(tripDashboardError(message));
    } finally {
        dispatch(loadingTripDashboard(false));
    }
};
